export const CODE = 'コード';
export const ERROR_CODE = 'コードを入力してください';
